import React, { FC, ReactNode } from 'react';
import cn from 'classnames';

type Props = {
  offerCount: number;
  indexInOffers?: number;
  children?: ReactNode;
};

const UpsellOffer: FC<Props> = ({
  children,
  offerCount,
  indexInOffers,
  ...rest
}) => {
  const isLast = offerCount - 1 === indexInOffers;

  return (
    <div
      {...rest}
      className={cn(
        'mt-25 px-15',
        'md:flex md:justify-between md:items-start md:mt-none  md:pr-25 md:pl-15',
        isLast ? 'md:pb-20' : 'md:pb-40',
      )}
    >
      {children}
    </div>
  );
};

UpsellOffer.displayName = 'UpsellOffer';

export default UpsellOffer;
